/* import __COLOCATED_TEMPLATE__ from './index.hbs'; */
import Component from '@glimmer/component';
import SegmentModel from 'cio/models/segment';

interface CreatedArgs {
  audience: { segment: SegmentModel; adAccountId?: string };
  onClose(): void;
}
export default class Created extends Component<CreatedArgs> {
  cheerImage = new URL('cio/assets/images/cheer.png', import.meta.url).toString();
}
